/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pain_Areas_QuestionInputs */

const en_us2_onboarding_pain_areas_question = /** @type {(inputs: Onboarding_Pain_Areas_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where does it hurt?`)
};

const pt_br2_onboarding_pain_areas_question = /** @type {(inputs: Onboarding_Pain_Areas_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde está doendo?`)
};

const es_419_onboarding_pain_areas_question = /** @type {(inputs: Onboarding_Pain_Areas_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dónde te duele?`)
};

const pt_pt2_onboarding_pain_areas_question = /** @type {(inputs: Onboarding_Pain_Areas_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde é que dói?`)
};

const fr_fr2_onboarding_pain_areas_question = /** @type {(inputs: Onboarding_Pain_Areas_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où as-tu mal ?`)
};

const de_de2_onboarding_pain_areas_question = /** @type {(inputs: Onboarding_Pain_Areas_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo tut es weh?`)
};

const it_it2_onboarding_pain_areas_question = /** @type {(inputs: Onboarding_Pain_Areas_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove fa male?`)
};

/**
* | output |
* | --- |
* | "Where does it hurt?" |
*
* @param {Onboarding_Pain_Areas_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_pain_areas_question = /** @type {((inputs?: Onboarding_Pain_Areas_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pain_Areas_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_pain_areas_question(inputs)
	if (locale === "es-419") return es_419_onboarding_pain_areas_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_pain_areas_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_pain_areas_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_pain_areas_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_pain_areas_question(inputs)
	return en_us2_onboarding_pain_areas_question(inputs)
});
export { onboarding_pain_areas_question as "onboarding.pain_areas.question" }